import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
// Extend DayJS with plugins
dayjs.extend(utc);
